import { cn } from "../../lib/utils";

/**
 * Loading placeholder. Sized by the caller via className so it can stand in
 * for whatever it's replacing — a line of text, an avatar, a button.
 */
function Skeleton({ className, ...props }) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export { Skeleton };
